import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import React from "react";

import "./App.css";
import SummaryPage from "./pages/SummaryPage";
import theme from "./styles/theme";

const urlSearchParams = new URLSearchParams(window.location.search);

const iso = urlSearchParams.get("iso");

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <SummaryPage iso={iso} />
      </div>
    </ThemeProvider>
  );
}

export default App;
